import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum PhoneNumberPermissionSet {
  View = 'communication_view',
  Configure = 'communication_configure',
  Purchase = 'communication_create',
  Delete = 'communication_delete',
}

// Ignore prettier to ensure only one permission per line
// prettier-ignore
export const phoneNumberPermissionSetGrouping: IPermissionSetGrouping<PhoneNumberPermissionSet> = {
  key: PermissionSetGroupingKey.PhoneNumber,
  active: {
    [PhoneNumberPermissionSet.View]: [
      PermissionType.GET_ANY_PHONE_NUMBER,
      PermissionType.GET_ANY_TWILIO_CONNECTION,
    ],
    [PhoneNumberPermissionSet.Configure]: [
      PermissionType.UPDATE_ANY_PHONE_NUMBER,
    ],
    [PhoneNumberPermissionSet.Purchase]: [
      PermissionType.PURCHASE_ANY_PHONE_NUMBER,
    ],
    [PhoneNumberPermissionSet.Delete]: [
      PermissionType.DELETE_ANY_PHONE_NUMBER,
    ],
  },
  unAssignablePermissionSets: [],
}
